import { PathElement } from './path-element.ts';
import { MatchingContext } from '../path-pattern.ts';

/*internal*/ export class WildcardSegmentsPathElement extends PathElement {
    constructor(pos: number, separator: number) {
        super(pos, separator);
    }

    matches(pathIndex: number, matchingContext: MatchingContext): boolean {
        // wildcard segments at the start of the pattern
        if (pathIndex === 0 && this.next !== undefined) {
            let endPathIndex = pathIndex;
            while (endPathIndex < matchingContext.pathLength) {
                if (this.next.matches(endPathIndex, matchingContext)) {
                    return true;
                }
                endPathIndex++;
            }
            return false;
        }
        // match until the end of the path
        else if (pathIndex < matchingContext.pathLength && !matchingContext.isSeparator(pathIndex)) {
            return false;
        }
        if (matchingContext.determinedRemainingPath) {
            matchingContext.remainingPathIndex = matchingContext.pathLength;
        }
        return true;
    }

    get normalizedLength() {
        return 1;
    }

    get chars(): Uint16Array {
        const s = `${String.fromCharCode(this.separator)}**`;
        const result = new Uint16Array(s.length);
        for (let i = 0; i < s.length; i++) {
            result[i] = s.charCodeAt(i);
        }
        return result;
    }

    get wildcardCount() {
        return 1;
    }

    toString() {
        return `WildcardSegments(${String.fromCharCode(this.separator)}**)`;
    }
}
